import { SnackbarVariantsEnum } from '../_props';

/**
 * Snackbar Variants Classes
 */

const snackbarVariantClassesMap = new Map([
  [SnackbarVariantsEnum.Primary, 'bg-neutrals-700'],
  [SnackbarVariantsEnum.Secondary, 'bg-neutrals-200'],
]);

/**
 * Snackbar Content Classes
 */

const snackbarContentVariantClassesMap = new Map([
  [SnackbarVariantsEnum.Primary, 'font-bold text-white'],
  [SnackbarVariantsEnum.Secondary, 'text-neutrals-600'],
]);

/**
 * Snackbar Content Classes
 */

const snackbarContentClasses = 'paragraph-s font-medium flex-1';

/**
 * Snackbar Blog Theme
 */
const snackbarClassesEach = 'justify-center';
const snackbarContainerClassesTheme = '';

const snackbarBlogTheme = {
  snackbarVariantClassesMap,
  snackbarContentVariantClassesMap,
  snackbarContentClasses,
  snackbarClassesEach,
  snackbarContainerClassesTheme,
};

export default snackbarBlogTheme;
